import React, { memo, useState } from "react";
import { IconButton, InputAdornment } from "@mui/material";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import { Controller } from "react-hook-form";
import StyledFormControl from "./StyledFormControl";
import StyledTextField from "./StyledTextField";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import StyledToolTip from "../UI/StyledToolTip";

const StyledTextInput = ({
  name,
  control,
  rules = {},
  defaultValue = "",
  type = "text",
  label,
  sx = {},
  onChange = null,
  onKeyDown = null,
  showError = true,
  disabled = false,
  ...props
}) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      defaultValue={defaultValue}
      render={({ field, fieldState, formState: { name: fieldName } }) => {
        const { error } = fieldState;
        const {
          showLabel = true,
          helperText = error?.message || props.helperText,
        } = props;
        const isPasswordField = type === "password";
        const inputType = isPasswordField
          ? showPassword
            ? "text"
            : "password"
          : "text";
        return (
          <StyledFormControl
            label={label}
            id={name}
            helperText={showError ? helperText : null}
            error={!!error}
            showLabel={showLabel}
            sx={{ ...sx }}
          >
            <StyledToolTip
              title={showError ? "" : helperText || ""}
              arrow
              placement="top"
            >
              <StyledTextField
                {...field}
                {...props}
                type={inputType}
                error={!!error}
                variant="outlined"
                onKeyDown={onKeyDown}
                disabled={disabled}
                value={field.value ?? ""}
                onChange={(e) => {
                  if (!!onChange) {
                    onChange(e, field.onChange, fieldName);
                  } else {
                    field.onChange(e);
                  }
                }}
                endAdornment={
                  <InputAdornment sx={{ marginLeft: 0 }} position="end">
                    {error ? (
                      <ErrorOutlineOutlinedIcon
                        sx={(theme) => ({ color: theme.palette.error.dark })}
                      />
                    ) : null}
                    {isPasswordField && !!field.value ? (
                      <IconButton
                        onClick={() => setShowPassword((prev) => !prev)}
                        edge="end"
                        size="small"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    ) : null}
                  </InputAdornment>
                }
                aria-description={`${name}-helper-text`}
              />
            </StyledToolTip>
          </StyledFormControl>
        );
      }}
    />
  );
};

export default memo(StyledTextInput);
